import { spawn, call, put, takeLatest } from 'redux-saga/effects';
import { createAction } from '@reduxjs/toolkit';
import { globalDataActions } from '../../../application/actions/globalData';
import { appActions } from '../../../application/actions/aplication'


import api from '../../api/index';

const apiRequest = api(process.env.REACT_APP_HOST);

// COURT
export function* getAllCourtFectc(e) {
    yield put(appActions.conexionApp({ connection: true }))
    yield put(globalDataActions.connectionGlobalDataLocation({connection:true}));
    try {
        
        const url = `data/court`
        const response = yield call(
            apiRequest.get,
            url
        );

        // Extraigo todos los datos
        const { data } = response;
        yield put(globalDataActions.createGlobalDataCourt({data}));
    } catch (err) {
        yield put(globalDataActions.errorGlobalDataCourt({error:true, message:err.message}));
    } finally {
        yield put(globalDataActions.connectionGlobalDataLocation({connection:false}));
        yield put(appActions.conexionApp({ connection: false }))
    }
}

// LOCATION
export function* getAllLocationFetch(e) {
    yield put(appActions.conexionApp({ connection: true }))
    yield put(globalDataActions.connectionGlobalDataLocation({connection:true}));
    try {
        
        const url = `data/location`
        const response = yield call(
            apiRequest.get,
            url
        );

        // Extraigo todos los datos
        const { data } = response;
        yield put(globalDataActions.createGlobalDataLocation({data}));
    } catch (err) {
        yield put(globalDataActions.errorGlobalDataLocation({error:true, message:err.message}));
    } finally {
        yield put(globalDataActions.connectionGlobalDataLocation({connection:false}));
        yield put(appActions.conexionApp({ connection: false }))
    }
}

export function* watchFetchSesion() {
    yield takeLatest(globalDataActionsSaga.getAllCourt.type,  getAllCourtFectc);
    yield takeLatest(globalDataActionsSaga.getAllLocation.type,  getAllLocationFetch);
}

export default function* rootSaga() {
    yield spawn(watchFetchSesion);
}


const getAllCourt = createAction('globalDataSaga/getAllCourt');
const getAllLocation = createAction('globalDataSaga/getAllLocation');

export const globalDataActionsSaga = {
    getAllCourt,
    getAllLocation
};
